import React from 'react';

import { NerdMenuElementType } from 'src/common/enums';
import { isServer } from 'src/utils/environment';
import NerdMenuComponent from './NerdMenuComponent';
import NerdMenuLinkListHeading from './NerdMenuLinkListHeading';
import { BoldLink, OutlinedLink } from './NerdMenuLinks';

const NerdMenuLinkListWrapper: React.FC<{
  linkListWrapper: NerdMenuElement;
  isMobileStack?: boolean;
}> = ({ linkListWrapper, isMobileStack = false }) => {
  return (
    <div className="pds-flex pds-flex-col pds-gap-0 pds-rounded pds-px-4 pds-py-0 md:pds-gap-4 md:pds-py-4">
      {linkListWrapper.menuElements?.map(element => {
        // LinkList
        if (element.type === NerdMenuElementType.LINK_LIST_HEADING) {
          return (
            <NerdMenuLinkListHeading
              isMobileStack={isMobileStack}
              linkListHeading={element}
              key={element.drupal_id}
            />
          );
        }

        // Bold link
        if (element.type === NerdMenuElementType.BOLD) {
          return <BoldLink key={element.drupal_id} link={element} />;
        }

        if (element.type === NerdMenuElementType.OUTLINED) {
          return <OutlinedLink key={element.drupal_id} link={element} />;
        }

        if (element.type === NerdMenuElementType.COMPONENT) {
          return <NerdMenuComponent component={element} key={element.drupal_id} />;
        }

        if (!isServer()) {
          // eslint-disable-next-line no-console
          console.warn('Unknown element type in link list wrapper', element);
        }

        return null;
      })}
    </div>
  );
};

export default NerdMenuLinkListWrapper;
